import { useEffect, useRef, useCallback, useState } from "react";
import { io, Socket } from "socket.io-client";
import apiConfig from "../axios";

const SOCKET_URL = apiConfig.defaults.baseURL;

const getToken = (): string => {
  const token = localStorage.getItem("token");
  if (token) return token;

  try {
    const userData = localStorage.getItem("userData");
    if (userData) {
      const parsed = JSON.parse(userData);
      if (parsed?.token) return parsed.token;
    }
  } catch (e) {
    //console.error("Token parse error:", e);
  }
  return sessionStorage.getItem("token") || "";
};

let socketInstance: Socket | null = null;
const listeners = new Set<(s: Socket | null) => void>();

const updateGlobalSocket = (s: Socket | null) => {
  socketInstance = s;
  listeners.forEach(l => l(s));
};

export default function useSocket() {
  const [socket, setSocket] = useState<Socket | null>(socketInstance);

  useEffect(() => {
    listeners.add(setSocket);
    return () => {
      listeners.delete(setSocket);
    };
  }, []);

  const connect = useCallback((): Socket | null => {
    const token = getToken();
    if (socketInstance) {
      if (socketInstance.disconnected) {
        socketInstance.connect();
      }
      return socketInstance;
    }

    const newSocket = io(SOCKET_URL, {
      auth: { token },
      transports: ["websocket"],
      reconnection: true,
      reconnectionAttempts: 5,
      reconnectionDelay: 2000,
    });

    newSocket.on("connect", () => {
      //console.log("Socket connected:", newSocket.id);
      updateGlobalSocket(newSocket);
    });

    newSocket.on("connect_error", (err: Error) => {
      //console.error("Socket connection error:", err.message);
    });

    newSocket.on("disconnect", (reason: string) => {
      //console.log("⚠️ Socket disconnected:", reason);
      if (reason === "io server disconnect" || reason === "transport close") {

      }
    });

    updateGlobalSocket(newSocket);
    return newSocket;
  }, []);

  const disconnect = useCallback((): void => {
    if (socketInstance) {
      socketInstance.disconnect();
      updateGlobalSocket(null);
    }
  }, []);

  const getSocket = useCallback((): Socket | null => {
    return socketInstance;
  }, []);

  useEffect(() => {
    connect();
  }, [connect]);

  return { connect, disconnect, getSocket, socket };
}
